import { Link } from "react-router";
import { Notice } from "@williampollardco/portal-ui";
import type { LinkBlock } from "@shared-core/domain/portal-sign-in/types";
import { Button } from "../../app/components/primitives/button";
import { Card } from "../../app/components/primitives/card";

/**
 * The offer on a quote opened from its emailed link by the order contact who has an open invite and no account yet
 * (`link.invited-order-contact.create-account-first`, docs/features/portal-sign-in/08, 5.3). Creating the account is the
 * page's one call to action; *Skip for now* is quieter and only hides the offer for this view of the page.
 */
export function AccountOfferCard({
  offer,
  signInHref,
  onSkip,
}: {
  offer: NonNullable<LinkBlock["accountOffer"]>;
  /** Where creating the account starts: the sign-in's create-your-account screen for this link. */
  signInHref: string;
  onSkip: () => void;
}) {
  return (
    <Card className="gap-3 p-5">
      <Notice tone="info">
        Pollards has invited <b>{offer.address}</b> to the portal for{" "}
        {offer.partyName}. With an account, you can see all your orders and
        order again.
      </Notice>
      <Button asChild className="w-full">
        <Link to={signInHref}>Create your account to accept the quote</Link>
      </Button>
      <p className="text-center text-[12.5px] text-muted-foreground">
        <button
          type="button"
          className="text-[12.5px] font-medium text-primary underline underline-offset-2"
          onClick={onSkip}
        >
          Skip for now
        </button>{" "}
        &middot; The invite lasts until {offer.inviteExpiresOn}.
      </p>
    </Card>
  );
}
